import { useQuery } from "@tanstack/react-query";
import { useAtom, useAtomValue } from "jotai";

import { UserRecordActivity } from "../../../../../types/GlobalInterfaces";
import {
  tenantIDAtom,
  userRecordActivityAtom,
} from "../../../../../atoms/GlobalAtoms";
import useUser from "../../../../../api/api-hooks/auth/useUser";
import API from "../../../../../api/api/API";

export default function useUserRecordActivity() {
  const { user } = useUser();
  const tenantID = useAtomValue(tenantIDAtom);
  const [savedUserRecordActivity, setSavedUserRecordActivity] = useAtom(
    userRecordActivityAtom
  );

  const userRecordActivity = useQuery({
    queryKey: ["userRecordActivity", tenantID, user?.id],
    queryFn: async () => {
      return API.getUserRecordActivity(user?.id)
        .then((data) => {
          let userRecordActivity = data.data.data.userRecordActivity;

          setSavedUserRecordActivity(userRecordActivity);
          return userRecordActivity || {};
        })
        .catch(() => {
          setSavedUserRecordActivity(undefined);
          return {};
        });
    },
    enabled: !!user,
    staleTime: Infinity,
  });

  return {
    userRecordActivity:
      savedUserRecordActivity ||
      (userRecordActivity.data as UserRecordActivity),
    loading: !savedUserRecordActivity && userRecordActivity.isLoading,
  };
}
